// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1-NDV","validationTips":"StatementDescriptor_validationTips__2ZkdF"};